import _jsx from '@babel/runtime/helpers/esm/jsx';
import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useMakeSelect } from '@dbh/reselect-extra';
import SmartSection from '@dbh/smart-section';
import { ADMINDEV_WEBCONTROLS_REFERENCES } from '@dbh/admindev-constants';
import { makeSelectWebcontrolsLoaded, makeSelectWebcontrolByReference, findEntriesElementsByReferencesInWebControl } from '@dbh/webcontrols-redux';

const TopCitiesSection=/*#__PURE__*/memo(()=>{const a=useMakeSelect(makeSelectWebcontrolsLoaded),b=useSelector(useMemo(()=>makeSelectWebcontrolByReference(ADMINDEV_WEBCONTROLS_REFERENCES.TOP_CITIES_GENERAL),[]));if(!a||!b)return null;const c=findEntriesElementsByReferencesInWebControl(b,["root","links"]),d=c.get("root"),e=c.get("links"),f=b?b.get("headingText"):void 0,g=b.get("htmlTag");return/*#__PURE__*/_jsx(SmartSection,{elements:d,links:e,title:f,htmlTag:g})});TopCitiesSection.displayName="TopCitiesSection";

export { TopCitiesSection as default };
